import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { getBudget } from "@fuse/utils";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import jwtDecode from "jwt-decode";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { toast } from "react-toastify";
// import { yupResolver } from '@hookform/resolvers/yup';
// import { Controller, useForm } from 'react-hook-form';
// import * as yup from 'yup';
// import _ from '@lodash';
// import jwtService from '../../auth/services/jwtService';

const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.marketingBudget}`;

// const schema = yup.object().shape({
//     categoryName: yup.string().required('You must enter category name'),
//     subcategoryName: yup.string().required('You must enter sub category name'),
//     childCategoryName: yup.string().required('You must enter child category name'),
// });

// const defaultValues = {
//     categoryName: '',
//     subcategoryName: '',
//     childCategoryName: '',
// };

export default function AddCategoryDialog(props) {
  const { openEdit, oldCategoryName, categoryData, newCategory } = props;
  const [open, setOpen] = useState(false);
  const [categoryName, setCategoryName] = useState(oldCategoryName);
  const [subcategoryName, setSubcategoryName] = useState("");
  const [childCategoryName, setChildCategoryName] = useState("");
  const [years, setYears] = useState("");
  const [categoryErr, setCategoryErr] = useState(false);
  const [selectedYear, setSelectedYear] = useState({
    value: new Date().getFullYear(),
  });
  const [user, setUser] = useState({});

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = async () => {
    await setOpen(false);
    setCategoryErr(false);
    await props.setOpenDialog(false);
    setTimeout(function () {
      props.setOpenEdit(false);
      props.setOldCategoryName("");
    }, 1000);
  };

  const handleChangeCategoryName = (e) => {
    setCategoryName(e.target.value);
    props.setOldCategoryName(e.target.value);
  };
  const handleChangeSubcategoryName = (e) => {
    setSubcategoryName(e.target.value);
  };
  const handleChangeChildCategoryName = (e) => {
    setChildCategoryName(e.target.value);
  };

  // const { control, formState, handleSubmit, reset } = useForm({
  //     mode: 'onChange',
  //     defaultValues,
  //     resolver: yupResolver(schema),
  // });

  // const { isValid, dirtyFields, errors, setError } = formState;

  // function onSubmit({ categoryName, subcategoryName, childCategoryName }) {
  //     jwtService
  //         .createUser({
  //             categoryName,
  //             subcategoryName,
  //             childCategoryName,
  //         })
  //         .then((user) => {

  //         })
  //         .catch((_errors) => {
  //             _errors.forEach((error) => {
  //                 setError(error.type, {
  //                     type: 'manual',
  //                     message: error.message,
  //                 });
  //             });
  //         });
  // }

  const handleSubmit = async () => {
    let sameCategory = categoryData.some(
      (item) => item.categoryName.toLowerCase() === categoryName.toLowerCase()
    );
    console.log(sameCategory);
    if (sameCategory) {
      setCategoryErr(true);
    } else {
      const payload = {
        categoryId: 0,
        year: selectedYear.value,
        categoryName: categoryName,
        budgets: getBudget(),
        reportToId: 0,
        status: "APPROVED",
        createdBy: user.email,
        createdDate: new Date(),
        updatedBy: user.email,
        updatedDate: new Date(),
        subCategories: [
          {
            subCategoryId: subcategoryName,
            subCategoryName: subcategoryName,
            budgets: getBudget(),
            reportToId: 0,
            budgetStatus: "APPROVED",
            subCategories: [
              {
                subCategoryId: childCategoryName,
                subCategoryName: childCategoryName,
                budgets: getBudget(),
                reportToId: 0,
                budgetStatus: "APPROVED",
              },
            ],
          },
        ],
      };
      if (props.openEdit === false) {
        try {
          const res = await OAuthService.addData(
            url + `/addBudgetCategory`,
            payload
          );
          props.loadDate();
          toast.success("Category Add Successfully");
          setCategoryName("");
          setSubcategoryName("");
          setChildCategoryName("");
        } catch (error) {
          console.log("error", error);
          // setError(error.message)
          // return true
        }
      } else {
        props.handleSave();
      }
      await handleClose();
    }
  };

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      const decode = jwtDecode(token);
      setUser(decode);
    }
  }, [token]);

  useEffect(() => {
    let currentYears = new Date().getFullYear() + 1;
    let allYears = [];
    for (let i = 0; i < 5; i++) {
      allYears.push({
        label: currentYears,
        value: currentYears,
      });
      currentYears -= 1;
    }
    setYears(allYears);
    changeYear(allYears[1]);
  }, []);

  const changeYear = (data) => {
    setSelectedYear(data);
    // loadDate(data)
  };

  const handleDisableButton = () => {
    if ((oldCategoryName === '' || childCategoryName === '' || subcategoryName === '') && !openEdit) {
      return true;
    } else if (oldCategoryName === '' && openEdit || newCategory === oldCategoryName.trim() && openEdit) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <IconButton aria-label="add" onClick={handleClickOpen}>
        <FuseSvgIcon size={34} color="action">
          heroicons-outline:plus-circle
        </FuseSvgIcon>
      </IconButton>
      <Dialog open={open || props.openDialog} onClose={handleClose}>
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              {openEdit === true ? "Update Category" : "Add Category"}
            </Typography>
            <IconButton onClick={handleClose}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        {/* <form
                    name="registerForm"
                    noValidate
                    className="flex flex-col justify-center w-full mt-32"
                    onSubmit={handleSubmit(onSubmit)}
                > */}
        <DialogContent>
          {openEdit === false && (
            <DialogContentText className="mb-16">
              To add to new category, please enter your category and sub
              category here. We will send updates occasionally.
            </DialogContentText>
          )}

          <Select
            name="year"
            placeholder="Select Year"
            value={selectedYear}
            onChange={changeYear}
            options={years}
            isDisabled={openEdit ? true : false}
            styles={customStyles()}
            className="mt-8 mb-16"
          />
          {/* <Controller
                            name="categoryName"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    className="mt-8 mb-16"
                                    label="Category Name"
                                    autoFocus
                                    //type="name"
                                    error={!!errors.categoryName}
                                    helperText={errors?.categoryName?.message}
                                    variant="outlined"
                                    required
                                    fullWidth
                                />
                            )}
                        /> */}
          <TextField
            error={categoryErr}
            helperText={
              categoryErr ? "Category with same name already exists" : ""
            }
            id="categoryName"
            label="Category"
            className="mt-8 mb-16"
            InputLabelProps={{
              shrink: true,
            }}
            name="categoryName"
            value={oldCategoryName}
            onChange={handleChangeCategoryName}
            variant="outlined"
            autoFocus
            required
            fullWidth
          />
          {/* <Controller
                            name="subcategoryName"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    className="mt-8 mb-16"
                                    label="SubCategory Name"
                                    autoFocus
                                    //type="name"
                                    error={!!errors.subcategoryName}
                                    helperText={errors?.subcategoryName?.message}
                                    variant="outlined"
                                    required
                                    fullWidth
                                />
                            )}
                        /> */}
          {openEdit === false && (
            <TextField
              id="subcategoryName"
              label="SubCategory"
              className="mt-8 mb-16"
              InputLabelProps={{
                shrink: true,
              }}
              name="subcategoryName"
              value={subcategoryName}
              onChange={handleChangeSubcategoryName}
              variant="outlined"
              autoFocus
              required
              fullWidth
            />
          )}
          {/* <Controller
                            name="childCategoryName"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    className="mt-8 mb-16"
                                    label="Child Category Name"
                                    autoFocus
                                    //type="name"
                                    error={!!errors.childCategoryName}
                                    helperText={errors?.childCategoryName?.message}
                                    variant="outlined"
                                    required
                                    fullWidth
                                />
                            )}
                        /> */}
          {/* Removed for ticket NT-707 */}
          {openEdit === false && (
            <TextField
              id="childCategoryName"
              label="Child Category"
              className="mt-8 mb-16"
              InputLabelProps={{
                shrink: true,
              }}
              name="childCategoryName"
              value={childCategoryName}
              onChange={handleChangeChildCategoryName}
              variant="outlined"
              autoFocus
              required
              fullWidth
            />
          )}
        </DialogContent>
        <DialogActions className="float-right px-8 sm:px-16 mb-16">
          <Button
            onClick={handleSubmit}
            // disabled={_.isEmpty(dirtyFields) || !isValid}
            disabled={handleDisableButton()}
            variant="contained"
            color="primary"
            type="submit"
          >
            Save
          </Button>
        </DialogActions>
        {/* </form> */}
      </Dialog>
    </>
  );
}
